<template>
    <div>
        <van-row class="title-row" type="flex" justify="space-between">
            <van-col span="10" class="col-center">
                <i class="icon-box"></i>
                <span class="section-title">条件专家TOP</span>
            </van-col>
            <van-col class="col-right algin-center" style="height: 100%; display: flex; align-items: center;" span="14">
                <SlideCapsuleTab :areaId="areaId" :tabIndex="tabIndex"></SlideCapsuleTab>
            </van-col>
        </van-row>
        <!-- 内容列表区 -->
        <div class="tab-wrapper">
            <!-- 选号推荐 -->
            <transition name="van-slide-left">
                <div v-if="tabIndex === 1" class="tab-content">
                    <van-row v-for="item in mavinList" :key="item.id" class="content-item" type="flex"
                        justify="space-between" align="center" @click="toMavinPage(item.id)">
                        <van-col span="4" class="col-center">
                            <span class="lottery">{{ item.lotteryId | lotteryNameFilter }}</span>
                        </van-col>
                        <van-col span="7" class="col-center font-middling">
                            <van-image class="head-img" round fit="contain" width="20" height="20"
                                :src="'/img/headImg/' + item.headImg" />
                            <div class="van-ellipsis" style="width: calc(100% - 24px);">{{ item.nickName }}</div>
                        </van-col>
                        <van-col span="6">
                            <div class="count">
                                近{{ days }}期中
                                <span class="win">{{ item.sumWinCount }}</span>
                            </div>
                        </van-col>
                        <van-col span="7" class="col-center algin-right">
                            <van-tag style="display: block; max-width: 96%;" class="van-ellipsis" type="primary">{{
                                item.playtypeName }}</van-tag>
                        </van-col>
                    </van-row>
                </div>
            </transition>
            <!-- 杀号推荐 -->
            <transition name="van-slide-right">
                <div v-if="tabIndex === 2" class="tab-content">
                    <van-row v-for="item in mavinList2" :key="item.id" class="content-item" type="flex"
                        justify="space-between" align="center" @click="toMavinPage(item.id)">
                        <van-col span="4" class="col-center">
                            <span class="lottery">{{ item.lotteryId | lotteryNameFilter }}</span>
                        </van-col>
                        <van-col span="7" class="col-center font-middling">
                            <van-image class="head-img" round fit="contain" width="20" height="20"
                                :src="'/img/headImg/' + item.headImg" />
                            <div class="van-ellipsis" style="width: calc(100% - 24px);">{{ item.nickName }}</div>
                        </van-col>
                        <van-col span="6">
                            <div class="count">
                                近{{ days }}期中
                                <span class="win">{{ item.sumWinCount }}</span>
                            </div>
                        </van-col>
                        <van-col span="7" class="col-center algin-right">
                            <van-tag style="display: block; max-width: 96%;" class="van-ellipsis" type="primary">{{
                                item.playtypeName }}</van-tag>
                        </van-col>
                    </van-row>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Image as VanImage, Tag, Col, Row } from 'vant';
import SlideCapsuleTab from '@/components/SlideCapsuleTab'

Vue.use(VanImage);
Vue.use(Tag);
Vue.use(Col);
Vue.use(Row);

export default {
    name: 'MavinListTopForCondition',
    props: ['mavinList', 'mavinList2', 'areaId', 'days'],
    components: { SlideCapsuleTab },
    data() {
        return {
            // tab页的tabIndex
            tabIndex: 1,
        }
    },
    mounted() {
        this.$bus.$on('slideTab', (attribute) => {
            // // 先触发父组件的数据加载事件,参数：areaId, days, attribute
            // this.$bus.$emit('change-playtype-attribute', this.areaId, this.days, attribute)
            this.tabIndex = attribute
        })
    },
    beforeDestroy() {
        this.$bus.$off('slideTab')
    },
    filters: {
        lotteryNameFilter(v) {
            if (v == '1') {
                return '福彩3D'
            } else if (v == '2') {
                return '排列三'
            }
        },
    },
    methods:{
        // 跳转专家页
        toMavinPage(id){
            this.$router.push({
                path: '/mavin',
                query: {
                    id
                }
            })
        },
    }
}
</script>

<style scoped>
/* tab动画效果样式 */
/* 关键：父容器相对定位，高度自适应 */
.tab-wrapper {
    position: relative;
    height: 228px;
    /* 根据实际内容调整 */
    overflow: hidden;
}

/* 关键：两个列表绝对定位，重叠在同一个位置 */
.tab-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}

/* 专家样式 */
.title-row {
    height: 28px;
}

.title-row .icon-box {
    display: inline-block;
    height: 20px;
    width: 8px;
    border-radius: 3px 0 0 3px;
    background-color: #F54B4A;
}

.title-row span.section-title {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    position: absolute;
    margin-left: 11px;
    font-size: 18px;
    font-weight: 700;
    color: #202020;
}

.title-row .col-right {
    text-align: right;
}

.title-row .col-right span {
    margin-right: 10px;
    font-size: 14px;
    font-weight: 500;
}

.title-row .col-right span.active {
    color: #F54B4A;
    border-bottom: 2px solid #F54B4A;
}

.title {
    display: block;
    font-size: 12px;
    color: #202020;
    line-height: 20px;
}

/* 内容列表样式 */
.content-item {
    margin-top: 16px;
}

.col-center {
    display: flex;
    align-items: center;
    height: 100%;
}

.font-middling {
    font-size: 13px;
}

.algin-right {
    justify-content: flex-end;
}

.lottery {
    border-radius: 3px;
    background-color: #F54B4A;
    color: #fff;
    font-size: 13px;
    text-align: center;
    padding: 4px 5px;
}

.head-img {
    margin: auto 3px;
}

.count {
    position: relative;
    overflow: hidden;
    width: 85px;
    height: 20px;
    text-align: left;
    line-height: 20px;
    font-size: 13px;
    border-radius: 4px;
    background: #fff;
    color: #F54B4A;
    border: 1px solid #F54B4A;
}

.count .win {
    border-radius: 0 4px 4px 0;
    background: #F54B4A;
    color: #fff;
    margin: 1px;
    display: block;
    height: 16px;
    width: 16px;
    line-height: 16px;
    text-align: center;
    padding: 1px 2px;
    float: right;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
}
</style>